import React from 'react';
import {
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

import { WordpressMenuQuery } from '../../../types';

const navItemBaseClassName = 'text-uppercase font-weight-bold';

export type ItemProps =
	WordpressMenuQuery['menu']['menuItems']['nodes'][number] & {
		isLast?: boolean;
		pixel?: string;
	};

export const Item: React.FC<ItemProps> = ({
	childItems,
	url,
	label,
	isLast,
	pixel
}) => {
	let className = navItemBaseClassName;

	if (isLast) {
		className += ' pr-0';
	}

	const handleClick = (e: React.MouseEvent, path?: string) => {
		e.preventDefault();

		// Fire TTD Pixel
		if (pixel) {
			const img = new Image();
			img.src = pixel;
		}

		// Navigate after short delay
		setTimeout(() => {
			if (path) {
				window.location.href = path;
			}
		}, 200);
	};

	if (childItems.nodes.length === 0) {
		return (
			<NavItem active={window.location.href === url}>
				<NavLink
					href={url ?? undefined}
					className={className}
					onClick={e => handleClick(e, url ?? undefined)}
				>
					{label}
				</NavLink>
			</NavItem>
		);
	}

	return (
		<UncontrolledDropdown nav inNavbar className="header-nav-bar-item">
			<DropdownToggle nav className={className}>
				{label}
			</DropdownToggle>

			<DropdownMenu className="rounded-0 border-1 border-gray shadow-lg">
				{childItems.nodes.map((node, key) => (
					<DropdownItem key={key}>
						<NavLink
							href={node.url ?? undefined}
							className={navItemBaseClassName}
						>
							{node.label}
						</NavLink>
					</DropdownItem>
				))}
			</DropdownMenu>
		</UncontrolledDropdown>
	);
};
